// extracted by mini-css-extract-plugin
export default {"pop_up":"styles_pop_up__ltRnk"};